<header class="container career-header">
  <div class="row">
    <nav id="w9" class="navbar-expand-xl py-0 p-lg-0 col-12 px-0 navbar">
      <a class="p-0 m-0 navbar-main__brand navbar-brand" href="/allasok/"
        ><img src="/angular/browser/img/header_logo_v2.svg" alt=""
      /></a>
      <button
        type="button"
        class="navbar-toggler--main collapsed navbar-toggler"
        data-bs-toggle="collapse"
        data-bs-target="#w9-collapse"
        aria-controls="w9-collapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div id="w9-collapse" class="collapse navbar-collapse">
        <ul id="w10" class="navbar-nav navbar__top-list nav">
          <li
            class="navbar__top-item navbar__top-item--first order-3 order-xl-1 nav-item"
          >
            <a
              class="navbar__top-link nav-link"
              [class.active]="isCareerPageActive"
              href="/allasok/"
              >Álláshirdetések</a
            >
          </li>
          <li class="navbar__top-item order-4 order-xl-2 nav-item">
            <a
              class="navbar__top-link nav-link"
              href="https://foxpost.hu"
              target="_blank"
              >foxpost.hu</a
            >
          </li>
        </ul>
      </div>
    </nav>
  </div>
</header>
